import { ref, computed, watch, nextTick } from 'vue'

export function useSnackbarNotificationQueue() {
  const notification = ref(false)
  const notificationText = ref('')
  const notificationColor = ref('')
  const notificationButtonColor = ref('amber')
  const notificationTimeout = ref(6000)
  const notificationTop = ref(false)
  const notificationBottom = ref(false)
  const notificationLeft = ref(false)
  const notificationRight = ref(false)
  const notificationMultiLine = ref(false)
  const notificationDark = ref(false)
  const notificationDismiss = ref(true)
  const notificationQueue = ref([])
  const hasNotificationsPending = computed(() => notificationQueue.value.length > 0)

  function processNotification(text, options) {
    notificationText.value = text

    if (options) {
      notificationColor.value = options.color || ''
      notificationButtonColor.value = options.buttonColor || (options.color ? 'dark' : 'amber')
      notificationTimeout.value = options.timeout ?? 6000
      notificationTop.value = options.top || false
      notificationBottom.value = options.bottom || false
      notificationLeft.value = options.left || false
      notificationRight.value = options.right || false
      notificationMultiLine.value = options.multiLine || false
      notificationDark.value = options.dark || false
      notificationDismiss.value = options.dismiss ?? true
    } else {
      // Reset to defaults if no options are provided
      notificationColor.value = ''
      notificationButtonColor.value = 'amber'
      notificationTimeout.value = 6000
      notificationTop.value = false
      notificationBottom.value = false
      notificationLeft.value = false
      notificationRight.value = false
      notificationMultiLine.value = false
      notificationDark.value = false
      notificationDismiss.value = true
    }
  }

  function addNotification(text, options) {
    if (text instanceof Error) {
      text = text.message
    }
    notificationQueue.value.push({ text, options })

    // If the snackbar is not currently active, trigger it immediately.
    if (!notification.value) {
      const nextNotification = notificationQueue.value.shift()
      processNotification(nextNotification.text, nextNotification.options)
      notification.value = true
    }
  }

  // This watcher handles showing the next notification from the queue after the current one is dismissed.
  watch(notification, (isActive) => {
    // When the snackbar becomes inactive (`notification` turns false) and there are more items...
    if (!isActive && hasNotificationsPending.value) {
      const nextNotification = notificationQueue.value.shift()
      processNotification(nextNotification.text, nextNotification.options)
      // Use nextTick to ensure the DOM has updated before showing the next notification.
      nextTick(() => {
        notification.value = true
      })
    }
  })

  function clearNotifications() {
    notificationQueue.value = [];     // Empty the queue
    notificationText.value = '';      // Clear text
    notification.value = false;       // Hide active snackbar
  }
  
  return {
    notification,
    notificationText,
    notificationColor,
    notificationButtonColor,
    notificationTimeout,
    notificationTop,
    notificationBottom,
    notificationLeft,
    notificationRight,
    notificationMultiLine,
    notificationDark,
    notificationDismiss,

    addNotification,
    clearNotifications,
  }
}